module.exports = __webpack_public_path__ + "static/media/bg-header.931cbc97.png";